/**
 * Created by Mark on 20/04/2017.
 */



export default class Class{
    constructor(uid , name , students){
        this.uid = uid;
        this.name = name;
        this.profileLink = this.getLink();
        this.students = students;
        this.assignedHomework  = 0
        this.completedHomework = 0;
        this.totalStudentsLink = this.getStudentsLink()
    }

    getLink(){
        return {link:'class/profile/'+this.uid ,  value:this.name};
    }

    getStudentsLink(){
        return {link:'class/profile/'+this.uid+'/2' ,  value:this.students.length};
    }

    getID(){
        return this.uid;
    }

    getName(){
        return this.name;
    }
}


// WEBPACK FOOTER //
// ./src/classes/class.js